export default (initialState: $TSFixMe, handlers: $TSFixMe) =>
    (state = initialState, action: $TSFixMe) => {
        const handler = action && action.type ? handlers[action.type] : undefined;

        if (!handler) {
            return state;
        }

        return handler(state, action.payload);
    };
